import React from 'react';

interface BookingHeaderProps {
  workflowName: string;
  description?: string;
}

const BookingHeader: React.FC<BookingHeaderProps> = ({ workflowName, description }) => (
  <div className="max-w-2xl mx-auto px-6 py-10 text-center">
    <h1 className="text-3xl font-bold text-gray-900">{workflowName}</h1>
    {description && (
      <p className="mt-3 text-gray-500 text-base">{description}</p>
    )}
  </div>
);

export default BookingHeader;
